import { useEffect, useCallback } from "react";
import { CirclePlus } from "lucide-react";
import Card from "./Card";

const CardsGroup = ({ 
    register, 
    errors, 
    setValue, 
    watch,
    groupName,
    fields,
    fieldTitle,
    userCanAdd = true
}) => {
    // 只監聽當前組的項目
    const watchItems = watch(groupName) || [];

    // 初始化處理
    useEffect(() => {
        if (watchItems.length === 0) {
            const initialItem = fields.reduce((acc, field) => {
                acc[field.name] = '';
                return acc;
            }, {});
            setValue(groupName, [initialItem], { 
                shouldValidate: true,
                shouldDirty: true,
                shouldTouch: false  // 避免觸發不必要的 touch 事件
            });
        }
    }, []);
  
    const addItem = useCallback(() => {
        const newItem = fields.reduce((acc, field) => {
            acc[field.name] = '';
            return acc;
        }, {});
        
        setValue(groupName, [...watchItems, newItem], {
            shouldValidate: true,
            shouldDirty: true,
            shouldTouch: false
        });
    }, [fields, groupName, setValue, watchItems]);
  
    const removeItem = useCallback((index) => {
        if (watchItems.length > 1) {  // 確保至少保留一個項目
            const newItems = watchItems.filter((_, i) => i !== index);
            setValue(groupName, newItems, {
                shouldValidate: true,
                shouldDirty: true,
                shouldTouch: false
            });
        }
    }, [groupName, setValue, watchItems]);
  
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {Array.isArray(watchItems) && watchItems.map((item, index) => (
                <Card
                    key={`${groupName}-${index}`}
                    index={index}
                    fields={fields}
                    register={register}
                    errors={errors}
                    onRemove={() => removeItem(index)}
                    groupName={groupName}
                />
            ))}
            
            {userCanAdd && (
                <button
                    type="button"
                    onClick={addItem}
                    className="my-auto p-2 w-fit h-fit flex flex-col items-center justify-center text-gray-500 hover:text-gray-700 hover:border-gray-400"
                >
                    <CirclePlus size={32} strokeWidth={1} />
                    <span className="mt-1 text-sm">新增</span>
                </button>
            )}
        </div>
    );
};

export default CardsGroup;